var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowLeftWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 9.99984L3.45952 9.29273L2.75241 9.99984L3.45952 10.7069L4.16663 9.99984ZM14.1666 10.9998C14.7189 10.9998 15.1666 10.5521 15.1666 9.99984C15.1666 9.44755 14.7189 8.99984 14.1666 8.99984V10.9998ZM6.79285 5.9594L3.45952 9.29273L4.87373 10.7069L8.20707 7.37361L6.79285 5.9594ZM3.45952 10.7069L6.79285 14.0403L8.20707 12.6261L4.87373 9.29273L3.45952 10.7069ZM4.16663 10.9998H14.1666V8.99984H4.16663V10.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowLeftWhite);
export default __webpack_public_path__ + "static/media/icon-arrow-left-white.9525322a7aaf0dcb2af2dd382d3226cc.svg";
export { ForwardRef as ReactComponent };